import BuildingType from "@/roc/building/BuildingType";
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const BanyanTree = {
  id: "132",
  name: "Banyan Tree",
  width: 3,
  height: 3,
  type: BuildingType.COLLECTABLE,
  era: "stoneAge",
  icon: "Banyan_Tree",
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Banyan_Tree',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asFlat(4),
      [
        ProductionCost.asCallbackWithLevel(
          (level) => {
            return 3500 * level;
          }
        ).withCurrency(ProductionCurrency.GOLD),
      ],
      ProductionDuration.asFlat(6 * 60 * 60),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          return 150 + ((level - 1) * 25);
        }
      ).withOutput(ProductionOutputType.ALL_PREVIOUS_ERA_GOODS),
    ),
  ]),
};

export default BanyanTree;
